import { useSelector } from '@xstate/react'
import { useUsersService } from 'providers'
import { useEffect, useRef } from 'react'
import { State } from 'xstate'
import { useRead } from './useRead'
import {
  RequestMachineContext,
  RequestMachineEventData,
  RequestMachineStates,
} from 'machines/requestMachine'
import { AnyUserData } from 'types'

export const useUserFromStore = (id: string): AnyUserData | undefined => {
  const user = useSelector(
    // @ts-ignore
    useUsersService(),
    (state: any) => {
      return state.context.users[id]
    }
  )
  return user
}

export const useUser = (
  id: string,
  onlyFresh?: boolean
): [
  AnyUserData | undefined,
  State<RequestMachineContext, RequestMachineEventData, RequestMachineStates>
] => {
  const user = useUserFromStore(id)
  const [read, readState] = useRead()
  const alreadyRead = useRef<boolean>(false)
  if (!user) alreadyRead.current = false
  useEffect(() => {
    if (id && !user) {
      alreadyRead.current = true
      read(id)
    }
  }, [read, id, user, alreadyRead])

  useEffect(() => {
    if (id && onlyFresh && !alreadyRead.current) {
      alreadyRead.current = true
      read(id)
    }
  }, [read, id, onlyFresh, alreadyRead])

  return [user, readState]
}
